/**
 * Заводы, с которых груз едет из Беларуси.
 *
 * Роман, 28.10.2026: оформление грузовых машин из Беларуси после новых правил
 * занимает заметно дольше, и менеджер обязан закладывать в срок не меньше
 * четырёх рабочих дней. Предупреждение должно попадаться на глаза в расчёте, а
 * не прятаться в подсказке у названия завода.
 *
 * Почему список, а не поле «регион»: регион в справочнике производств им забит
 * как попало — в «Беларуси» лежат Архангельск, Брянск, Белгород, Кострома и
 * Нижний Новгород. Вешать плашку по этому полю нельзя, она вылезет где попало.
 * Пока список явный; когда в справочнике появится честная страна — перейти на
 * неё и этот файл удалить.
 *
 * Названия отличаются между контурами («КСИ Могилевский» на тесте и «КСИ
 * Могилевский (МСК)» на бою), поэтому сверяем по образцу, а не по равенству.
 */

const BELORUSSKIE = [
  /могил[еёе]вский\s+газосиликат/i,
  /кси\s+могил[еёе]вский/i,
];

export const BELARUS_PREDUPREZHDENIE =
  'Обратите внимание: оформление грузовых автомобилей из Беларуси требует больше '
  + 'времени в связи с введением новых правил. Обязательно закладывайте не менее '
  + '4 рабочих дней на ожидание оформления. Просим направлять заявки заблаговременно, '
  + 'чтобы мы успели подготовить документы и соблюсти сроки поставки.';

/** Везёт ли этот завод из Беларуси. */
export const belorusskiyZavod = (nazvanie) => {
  const stroka = String(nazvanie || '');
  return BELORUSSKIE.some((obrazec) => obrazec.test(stroka));
};

/** Есть ли среди строк сравнения хоть один белорусский завод. */
export const estBelorusskiyZavod = (stroki) =>
  (Array.isArray(stroki) ? stroki : []).some((stroka) =>
    belorusskiyZavod(stroka?.production || stroka?.comparison?.production || stroka));
